import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=55be5e7e&scoped=true&"
import script from "./Challenge.vue?vue&type=script&lang=js&"
export * from "./Challenge.vue?vue&type=script&lang=js&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=55be5e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be5e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55be5e7e')) {
      api.createRecord('55be5e7e', component.options)
    } else {
      api.reload('55be5e7e', component.options)
    }
    module.hot.accept("./Challenge.vue?vue&type=template&id=55be5e7e&scoped=true&", function () {
      api.rerender('55be5e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenges/Challenge.vue"
export default component.exports